<form [formGroup]="loginForm" (ngSubmit)="submitForm()">
  <p-inputgroup class="mb-8">
    <p-inputgroup-addon>
      <i class="pi pi-user"></i>
    </p-inputgroup-addon>
    <p-float-label>
      <input [id]="id + 'email'" pInputText type="email" formControlName="email"
        [pTooltip]="formWatched['children']['email']() | formFieldFeedback" tooltipEvent="focus"
        tooltipPosition="bottom" required />
      <label [for]="id + 'email'">E-mail</label>
    </p-float-label>
  </p-inputgroup>
  <p-inputgroup class="">
    <p-inputgroup-addon>
      <i class="pi pi-lock"></i>
    </p-inputgroup-addon>
    <p-float-label>
      <input [id]="id + 'password'" pInputText type="password" formControlName="password"
        [pTooltip]="formWatched['children']['password']() | formFieldFeedback" tooltipEvent="focus"
        tooltipPosition="bottom" required />
      <label [for]="id + 'password'">Senha</label>
    </p-float-label>
    <br>
  </p-inputgroup>
  <div routerLink="/forgot-password" routerLinkActive="router-link-active"
    class="text-gray-400 hover:text-blue-500 hover:font-semibold mt-4 hover:cursor-pointer text-right">Esqueci a senha
  </div>
  <p-button styleClass="w-full mb-4 mt-8" label="Acessar" [loading]="isLoading()" [disabled]="isLoading()"
    type="submit" />
</form>